import React, { Fragment } from "react";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { adjustUrl } from "@danishagro/shared/src/helpers/adjustUrl.helper";
import { Helmet } from "react-helmet";
import { DA_BasicLink } from "../../atoms/BasicLink/BasicLink.component";
import { DA_Icon, DA_IconNames } from "../../atoms/Icon/Icon.component";
import { useAppData } from "../../../contexts/appData.context";
import { DA_BreadcrumbProps } from "./Breadcrumb.interface";
import S from "./Breadcrumb.module.scss";

export const DA_Breadcrumb = (props: DA_BreadcrumbProps) => {
    const { currentSite } = useAppData();
    const showNumberedListClass = props.showNumberedList ? S.showNumberedList : undefined;

    // Use schemaItems if provided, otherwise use breadcrumbItems for schema
    const itemsForSchema = props.schemaItems || props.breadcrumbItems;

    // Generate JSON-LD Breadcrumb data
    const breadcrumbJsonLd = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: itemsForSchema.map((item, index) => ({
            "@type": "ListItem",
            position: index + 1,
            item: {
                // For items with onClick (like "..."), use "/" as default for schema
                "@id": item.href
                    ? adjustUrl(item.href, currentSite)
                    : item.onClick
                    ? "/"
                    : undefined,
                name: item.title,
            },
        })),
    };

    return (
        <nav className={showNumberedListClass}>
            <Helmet>
                <script type="application/ld+json">{JSON.stringify(breadcrumbJsonLd)}</script>
            </Helmet>
            <ol className={cn(S.list, props.hideOnMobile && S.hideOnMobile, props.listClassName)}>
                {props.breadcrumbItems.map((item, index) => {
                    const hasLink =
                        !(index === 0 && currentSite === "MYFARM") &&
                        ((index !== props.breadcrumbItems.length - 1 && item.href) ||
                            (index === props.breadcrumbItems.length - 1 &&
                                props.lastIsLink &&
                                item.href));

                    const isHighlightedClass = item.isHighlighted ? S.isHighlighted : undefined;
                    return (
                        <Fragment key={index}>
                            <li className={cn(S.item, isHighlightedClass)}>
                                {hasLink ? (
                                    <DA_BasicLink
                                        href={adjustUrl(item.href, currentSite)}
                                        className={S.link}
                                    >
                                        <span>{item.title}</span>
                                    </DA_BasicLink>
                                ) : item.onClick ? (
                                    <button
                                        onClick={item.onClick}
                                        className={cn(S.title, S.expandBtn)}
                                    >
                                        {item.title}
                                    </button>
                                ) : (
                                    <span className={S.title}>{item.title}</span>
                                )}
                            </li>
                            {index !== props.breadcrumbItems.length - 1 && (
                                <li>
                                    <DA_Icon
                                        className={S.divider}
                                        name={DA_IconNames.ChevronRight}
                                    />
                                </li>
                            )}
                        </Fragment>
                    );
                })}
            </ol>
        </nav>
    );
};
